import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EventData {
    date: string;
    event: string;
    location: string;
    startTime: string;
    endTime: string;
    excludedCategories?: number[];
    eventId?: number;
    canceled?: boolean;
}

type UIElementKey =
    | 'menu'
    | 'history'
    | 'admin'
    | 'user'
    | 'mailbox'
    | 'filter'
    | 'event'
    | 'absent'
    | 'agenda'
    | 'files'
    | 'schedule'
    | 'categoryRequest'
    | 'categoryRequestsReview'
    | 'scheduleTemplateSets'
    | 'changeRequests'
    | 'yearSummary'
    | 'personalForecast'
    | 'handbook';

interface UIState {
    open: Record<UIElementKey, boolean>;
    editEventData: EventData;
    forecast: number;
}

const initialState: UIState = {
    open: {
        menu: false,
        history: false,
        admin: false,
        user: false,
        mailbox: false,
        filter: false,
        event: false,
        absent: false,
        agenda: false,
        files: false,
        schedule: false,
        categoryRequest: false,
        categoryRequestsReview: false,
        scheduleTemplateSets: false,
        changeRequests: false,
        yearSummary: false,
        personalForecast: false,
        handbook: false,
    },
    editEventData: {
        date: '',
        event: '',
        location: '',
        startTime: '',
        endTime: '',
    },
    forecast: 15,
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggle: (state, action: PayloadAction<UIElementKey>) => {
            state.open[action.payload] = !state.open[action.payload];
        },
        open: (state, action: PayloadAction<UIElementKey>) => {
            state.open[action.payload] = true;
        },
        close: (state, action: PayloadAction<UIElementKey>) => {
            state.open[action.payload] = false;
        },
        openEventModal: (state, action: PayloadAction<EventData | undefined>) => {
            state.open.event = !!action.payload;
            state.editEventData = action.payload ?? {
                date: '',
                event: '',
                startTime: '',
                endTime: '',
                location: '',
            };
        },
        closeAll: (state) => {
            Object.keys(state.open).forEach((key) => {
                state.open[key as UIElementKey] = false;
            });
        },
        setForecast: (state, action: PayloadAction<number>) => {
            state.forecast = action.payload;
        },
    },
});

export const { toggle, open, close, openEventModal, closeAll, setForecast } = uiSlice.actions;

export default uiSlice.reducer;
